import { render } from "./ThankYouView.vue?vue&type=template&id=fe196d14&scoped=true&ts=true"
import script from "./ThankYouView.vue?vue&type=script&lang=ts"
export * from "./ThankYouView.vue?vue&type=script&lang=ts"

import "./ThankYouView.vue?vue&type=style&index=0&id=fe196d14&scoped=true&lang=scss"

import exportComponent from "/opt/atlassian/pipelines/agent/build/SurveyPublic/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fe196d14"]])

export default __exports__